import { Component, inject } from '@angular/core';
import { RecentSearchService } from '@services/recent-search.service';
import { ProductSearchService, ProductService } from '@spartacus/core';
import { SearchBoxComponent, SearchBoxOutlets } from '@spartacus/storefront';
import { CustomSearchBoxService } from './custom-searchbox.service';
import { catchError, EMPTY, tap } from 'rxjs';

@Component({
  selector: 'cx-searchbox',
  standalone: false,
  templateUrl: './custom-searchbox.component.html',
  styleUrl: './custom-searchbox.component.scss',
})
export class CustomSearchboxComponent extends SearchBoxComponent {
  recentSearchService = inject(RecentSearchService);
  customSearchBoxComponentService = inject(CustomSearchBoxService);
  searchService = inject(ProductSearchService);
  productService = inject(ProductService);

  override readonly searchBoxOutlets = SearchBoxOutlets;

  override get searchBoxV2(): boolean {
    return false;
  }

  override launchSearchResult(query: string): void {
    if (!query || query.trim().length === 0) {
      return;
    }
    this.forceClose();

    const queryTrim = query.trim();

    this.productService.get(queryTrim).pipe(
      tap((product) => {
        if (product && product.code) {
          this.routingService.go({ cxRoute: 'product', params: product });
        } else {
          this.searchBoxComponentService.launchSearchPage(queryTrim);
        }
      }),
      catchError((error) => {
        console.error('Error fetching product:', error);
        this.searchBoxComponentService.launchSearchPage(queryTrim);
        return EMPTY;
      })
    ).subscribe();
  }

  forceClose(event?: UIEvent): void {
    super.close();
  }
}
